/**
 * Created by Jim on 2018/5/14.
 * Modify by handd on 2018/5/15.
 * Upgrade antd 4 on 2022/9/8.
 */
import axios from "axios";

//const
export const EQUIPMENT_CERTIFY_REGISTER_UPDATE_DATA = "equipmentCertifyRegister/EQUIPMENT_CERTIFY_REGISTER_UPDATE_DATA";
export const EQUIPMENT_CERTIFY_REGISTER_INITIAL_DATA = "equipmentCertifyRegister/EQUIPMENT_CERTIFY_REGISTER_INITIAL_DATA";
export const EQUIPMENT_CERTIFY_REGISTER_TOGGLE_MODAL = "equipmentCertifyRegister/EQUIPMENT_CERTIFY_REGISTER_TOGGLE_MODAL";
export const EQUIPMENT_CERTIFY_REGISTER_TOGGLE_LOADING = "equipmentCertifyRegister/EQUIPMENT_CERTIFY_REGISTER_TOGGLE_LOADING";

export const EQUIPMENT_CERTIFY_REGISTER_MODAL_SUCCESS_TITLE = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_success_title";
export const EQUIPMENT_CERTIFY_REGISTER_MODAL_SUBMIT_SUCCESS_CONTENT = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_submitSuccess_content";
export const EQUIPMENT_CERTIFY_REGISTER_MODAL_FAIL_TITLE = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_submitFail_content";
export const EQUIPMENT_CERTIFY_REGISTER_MODAL_SUBMIT_FAIL_CONTENT = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_fail_title";
export const EQUIPMENT_CERTIFY_REGISTER_MODAL_OK_LABEL = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_OK_label";
export const EQUIPMENT_CERTIFY_REGISTER_MODAL_CANCEL_LABEL = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyRegister_modal_cancel_label";

//reducer
export const equipmentCertifyRegister = (state = {
  loading: false,
  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,
  rangeDate: [],
  description: "",
  registerDescription: "",
}, action) => {
  switch (action.type) {
    case EQUIPMENT_CERTIFY_REGISTER_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_CERTIFY_REGISTER_INITIAL_DATA:
      return {
        ...state,
        loading: false,
        modalVisible: false,
        rangeDate: [],
        description: "",
        registerDescription: "",
      };
    case EQUIPMENT_CERTIFY_REGISTER_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case EQUIPMENT_CERTIFY_REGISTER_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateEquipmentCertifyRegisterData = (data) => {
  return {
    type: EQUIPMENT_CERTIFY_REGISTER_UPDATE_DATA,
    data: data
  }
};

/**
 * submit equipment certify register
 * @deprecated since 20220909
 */
export const submitEquipmentCertifyRegister = (data) => {
  return (dispatch) => {
    dispatch(toggleLoading(true));
    console.log(data);
    axios({
      method: "POST",
      url: "/api-equipment/registerEquipmentCertify",
      contentType: "application/json",
      withCredentials: true,
      data: {
        "description": data.description,
        "beginDate": data.rangeDate[0],
        "endDate": data.rangeDate[1],
        "registerDescription": data.registerDescription,
        "registerUserId": data.releaseUserId,
        "registerUserName": data.releaseUserName,
        "registerCompanyId": data.releaseCompanyId,
        "registerCompanyName": data.releaseCompanyName,
      },
    }).then(
      response => {
        dispatch(toggleLoading(false));
        if (response.status === 200) {
          console.info("success submit equipment certify register");
          dispatch(toggleModal({
            modalVisible: true,
            modalTitle: EQUIPMENT_CERTIFY_REGISTER_MODAL_SUCCESS_TITLE,
            modalContent: EQUIPMENT_CERTIFY_REGISTER_MODAL_SUBMIT_SUCCESS_CONTENT,
            modalOk: EQUIPMENT_CERTIFY_REGISTER_MODAL_OK_LABEL,
            modalCancel: EQUIPMENT_CERTIFY_REGISTER_MODAL_CANCEL_LABEL,
            onOk: () => {
              dispatch(toggleModal({modalVisible: false}));
              this.props.history.goBack();
            },
            onCancel: () => {
              dispatch(toggleModal({modalVisible: false}));
              this.props.history.goBack();
            }
          }));
        } else {
          console.error("fail to submit equipment certify register");
          dispatch(toggleModal({
            modalVisible: true,
            modalTitle: EQUIPMENT_CERTIFY_REGISTER_MODAL_FAIL_TITLE,
            modalContent: EQUIPMENT_CERTIFY_REGISTER_MODAL_SUBMIT_FAIL_CONTENT,
            modalOk: EQUIPMENT_CERTIFY_REGISTER_MODAL_OK_LABEL,
            modalCancel: EQUIPMENT_CERTIFY_REGISTER_MODAL_CANCEL_LABEL,
            onOk: () => {
              dispatch(toggleModal({modalVisible: false}));
            },
            onCancel: () => {
              dispatch(toggleModal({modalVisible: false}));
            }
          }));
        }
      }
    );
  };
};


/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: EQUIPMENT_CERTIFY_REGISTER_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_CERTIFY_REGISTER_TOGGLE_LOADING,
    data: show
  }
};
